import Button from "../../../../components/button/button";
import { Card } from "../../../../components/card/card";

const DeviceList = ({ devices = [], onAddClick, onRemoveClick }) => {

    const hasDevices = devices && devices.length > 0;

    return(
        <>
            {!hasDevices ? (
                <p className="p-1">Nenhum dispositivo vinculado.</p>
            ) : (
                <div className="h-full min-h-0 overflow-auto rounded-md bg-white">
                    <table className="min-w-full border-collapse text-[13px] text-[#2E3742]">
                        <tbody className="divide-y divide-zinc-200">
                            {devices.map((d, idx) => (
                                <tr key={d?.id}>
                                    <td className={[
                                        "px-3 py-2 leading-[1.2]",
                                        idx % 2 === 0 ? "bg-[#efefef]" : "bg-white",
                                        idx === 0 ? "rounded-t-md" : "",
                                        idx === devices.length -1 ? "rounded-b-md" : "",
                                    ].join(" ")}>
                                        {d?.text ?? <span className="text-zinc-400">-</span>}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </>
    )
}

export default DeviceList;